import AgoraRTC from 'agora-rtc-react'
import { useEffect, useState } from 'react'
import { useMicrophoneAndCameraTracks } from './AgoraCommon'

export const useAgoraLocalTracks = () =>
{
	const { ready, tracks } = useMicrophoneAndCameraTracks()
	const [cameras, setCameras] = useState<MediaDeviceInfo[]>([])
	const [selectedCamera, setSelectedCamera] = useState<MediaDeviceInfo | undefined>()
	const [isLoadingDevices, setLoadingDevices] = useState(false)

	const loadDevices = () => {
		if (!isLoadingDevices) {
			setLoadingDevices(true)
			AgoraRTC.getCameras(true)
				.then((it) => setCameras(it))
				.finally(() => setLoadingDevices(false))
		}
	}

	useEffect(() => {
		if (ready){
			loadDevices()
		}
	}, [ready])

	useEffect(() => {
		if (ready && selectedCamera) {
			tracks?.[1].setDevice(selectedCamera.deviceId)
		}
	}, [ready, selectedCamera, tracks])

	return {
		availableCameras: cameras,
		setSelectedCamera,
		ready,
		tracks,
		isLoadingDevices,
		loadDevices
	}
}
